import CONNECTION from '../apiUrls';
import { client } from '../../../../../common-utils/libraries/axios/axios';

const mutationLoginFromTotp = (onSuccess, onError) => {
    return {
        mutationFn: ({ totp, token }) => {
            return client.post(CONNECTION.LOGIN_MFA.url, { totp, token });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationLoginFromTotp;